import { render, staticRenderFns } from "./UsageFeesOnlyPaymentRateTableRow.vue?vue&type=template&id=189d5ffa&scoped=true&lang=pug"
import script from "./UsageFeesOnlyPaymentRateTableRow.vue?vue&type=script&lang=ts"
export * from "./UsageFeesOnlyPaymentRateTableRow.vue?vue&type=script&lang=ts"
import style0 from "./UsageFeesOnlyPaymentRateTableRow.vue?vue&type=style&index=0&id=189d5ffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189d5ffa",
  null
  
)

export default component.exports